import { useEffect } from 'react';

export enum KeyboardKey {
	ESCAPE = 'Escape',
}

export function useKeyboardKeyListener(key: KeyboardKey, listener: (event: KeyboardEvent) => void) {
	useEffect(() => {
		const handler = (event: KeyboardEvent) => {
			const { code } = event;
			if (code !== key) {
				return;
			}
			listener(event);
		};

		document.addEventListener('keydown', handler);

		return () => {
			document.removeEventListener('keydown', handler);
		};
	}, [listener, key]);
}
